import { clsx } from "clsx";
import classes from "./Loading.module.scss";
import { LoadingProps } from "./LoadingProps";

export function Loading(props: LoadingProps) {
  const { className, message } = props;

  return (
    <div
      role="status"
      aria-live="polite"
      className={clsx(classes.wrapper, className)}
    >
      {message && <div className={classes.message}>{message}</div>}
      <div className={classes.loader} />
    </div>
  );
}
